import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ImagenHome.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-f12e2f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-f12e2f9e><section data-v-f12e2f9e><h1 class=\"title\" data-v-f12e2f9e>SOFTWARE PARA LA ADMINISTRACIÓN DE TU NEGOCIO</h1><p class=\"contenido\" data-v-f12e2f9e>Thotex es una plataforma diseñada para facilitar la gestión contable y financiera de pequeños y medianos comercios. Ofreciendo funcionalidades que permiten a los usuarios a gestionar inventarios, controlar la nómina, y realizar un seguimiento detallado de sus operaciones económicas.</p><input type=\"button\" class=\"login-button\" value=\"Comenzar ahora\" data-v-f12e2f9e></section><div class=\"image\" data-v-f12e2f9e><img src=\"" + _imports_0 + "\" alt=\"Imagen inicio\" height=\"600px\" width=\"600px\" data-v-f12e2f9e></div></div>", 1)
const _hoisted_3 = {
  id: "pqrFormSection",
  class: "subContainer"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Formulario PQRS", -1))
const _hoisted_5 = { class: "card-global card-centered posi" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Nombre", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Correo Electrónico", -1))
const _hoisted_9 = { class: "column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Asunto", -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled data-v-f12e2f9e>Selecciona una opción</option><option value=\"Petición\" data-v-f12e2f9e>Petición</option><option value=\"Queja\" data-v-f12e2f9e>Queja</option><option value=\"Reclamo\" data-v-f12e2f9e>Reclamo</option><option value=\"Sugerencia\" data-v-f12e2f9e>Sugerencia</option>", 5)
const _hoisted_16 = [
  _hoisted_11
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label" }, "Mensaje", -1))
const _hoisted_18 = {
  id: "pqrFormFAQS",
  class: "faq-section"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Preguntas Frecuentes", -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "faq-answer"
}

import { ref } from 'vue';
import swal from 'sweetalert';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const pqrForm = ref({
  name: '',
  email: '',
  subject: '',
  message: ''
});

const validateName = () => {
  pqrForm.value.name = pqrForm.value.name.replace(/\d+/g, '');
};

const submitForm = () => {
  if (pqrForm.value.name && pqrForm.value.email && pqrForm.value.subject && pqrForm.value.message) {
    console.log("Formulario enviado", pqrForm.value);
    swal("¡Genial!", "Tu solicitud PQRS ha sido enviada", "success");
  } else {
    swal("Error", "Por favor, completa todos los campos", "error");
  }
};

const faqs = ref([
  { question: '¿Cuál es la utilidad de un software contable para mi negocio?', answer: 'Un software contable, como Thotex, te ayuda a gestionar y automatizar procesos financieros y contables de tu negocio, como el control de inventarios, la gestión de nómina, y el seguimiento de ventas y compras. Esto te permite ahorrar tiempo, reducir errores, y tener una visión clara de la situación financiera de tu negocio, lo que facilita la toma de decisiones informadas.' },
  { question: '¿Cómo puede Thotex ayudarme a gestionar mi inventario de manera más eficiente?', answer: 'Thotex facilita la gestión de inventario permitiéndote registrar productos, actualizar automáticamente el stock con cada compra o venta, y visualizar gráficos de barras que muestran el total de ventas y compras realizadas. Estas herramientas te permiten tener un control más preciso del inventario, identificar tendencias, y tomar decisiones basadas en datos para optimizar la gestión de tus productos.' },
  { question: '¿Cuándo tienes dudas a dónde te puedes comunicar?', answer: 'Tenemos diversos  canales de comunicacón  disponibles para que puedas solicitar información o soporte. Pudes elegir entre nuestras redes sociales, nuestro chat bot o enviarnos un mensaje en la seccion de contactenos del home. Estamos listos para atenderte en el canal que prefieras' },
  { question: '¿Cómo se realiza el pago de la suscripción de Thotex?', answer: 'El pago de la suscripción se realiza a través de la sección de suscripción en la plataforma, que se encuentra en el perfil. Puedes elegir entre opciones de pago mensual o anual, y proporcionar la información de tu método de pago preferido.' },
  { question: '¿Cómo configuro notificaciones para eventos importantes en Thotex?', answer: 'Puedes configurar notificaciones en la sección de calendario. Aquí puedes agregar eventos importantes y establecer recordatorios para recibir notificaciones por correo electrónico o en la plataforma.' },
]);

const activeIndex = ref<number | null>(null);

const toggleAnswer = (index: number) => {
  activeIndex.value = activeIndex.value === index ? null : index;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "form-global",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              required: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pqrForm.value.name) = $event)),
              class: "input",
              type: "text",
              placeholder: "Nombre Completo",
              onInput: validateName
            }, null, 544), [
              [_vModelText, pqrForm.value.name]
            ]),
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pqrForm.value.email) = $event)),
              class: "input",
              type: "email",
              placeholder: "Correo Electrónico"
            }, null, 512), [
              [_vModelText, pqrForm.value.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("select", {
              required: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pqrForm.value.subject) = $event)),
              class: "input"
            }, _hoisted_16, 512), [
              [_vModelSelect, pqrForm.value.subject]
            ]),
            _hoisted_17,
            _withDirectives(_createElementVNode("textarea", {
              required: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pqrForm.value.message) = $event)),
              class: "textarea",
              placeholder: "Escribe tu mensaje aquí"
            }, null, 512), [
              [_vModelText, pqrForm.value.message]
            ])
          ])
        ], 32),
        _createElementVNode("div", { class: "flex-centered-button" }, [
          _createElementVNode("button", {
            class: "button-global btn-center",
            onClick: submitForm
          }, "Enviar")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs.value, (faq, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "faq-item"
        }, [
          _createElementVNode("div", {
            class: "faq-question",
            onClick: ($event: any) => (toggleAnswer(index))
          }, [
            _createElementVNode("h2", null, _toDisplayString(faq.question), 1),
            _createElementVNode("span", {
              class: _normalizeClass({ 'active': activeIndex.value === index })
            }, "+", 2)
          ], 8, _hoisted_20),
          (activeIndex.value === index)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("p", null, _toDisplayString(faq.answer), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})